import request, { serviceV2 } from '@/utils/request'

const v2Prefix = '/job'
const prefix = '/django_rest/company/job'

export default {
  createGenerateJobFitConditionTask (jobId) {
    return serviceV2.post(`${v2Prefix}/${jobId}/fit-condition/generate/`)
  },
  getJobFitConditionTask (jobId, taskId) {
    return serviceV2.get(`${v2Prefix}/${jobId}/fit-condition/generate/`, { params: { task_id: taskId } })
  },
  getJobFitCondition (jobId) {
    return serviceV2.get(`${v2Prefix}/${jobId}/fit-condition/`)
  },
  saveJobFitCondition (jobId, condition) {
    return serviceV2.put(`${v2Prefix}/${jobId}/fit-condition/`, condition)
  },
  createTestJobFitConditionTask (jobId, testInfo) {
    return request.post(`${prefix}/${jobId}/fit-condition/test/`, testInfo)
  },
  getTestJobFitConditionTask (jobId, taskId) {
    return request.get(`${prefix}/${jobId}/fit-condition/test/`, { params: { task_id: taskId } })
  },
  getRefreshJobFitTask (jobId) {
    return request.get(`${prefix}/${jobId}/refresh-fit/`)
  },
  createRefreshJobFitTask (jobId) {
    return request.post(`${prefix}/${jobId}/refresh-fit/`)
  }
}
